import { render, staticRenderFns } from "./CardContentDefault.vue?vue&type=template&id=4694cb94&scoped=true&"
import script from "./CardContentDefault.vue?vue&type=script&lang=js&"
export * from "./CardContentDefault.vue?vue&type=script&lang=js&"
import style0 from "./CardContentDefault.vue?vue&type=style&index=0&id=4694cb94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4694cb94",
  null
  
)

export default component.exports